module.exports = __webpack_public_path__ + "img/perche-red-white.1e633df5.svg";